import request from '@/utils/request'

//博客列表
export function user_boke_list(data) {
  return request({
    url: 'user_boke_list',
    method: 'post',
    data:data
  })
}

//帖子列表
export function tiezi_list(data) {
  return request({
    url: 'tiezi_list',
    method: 'post',
    data:data
  })
}

//论坛博客主题
export function zhuanti_list(data) {
  return request({
    url: 'zhuanti_list',
    method: 'post',
    data:data
  })
}

//专题基础数据
export function zhuanti_data(data) {
  return request({
    url: 'zhuanti_data',
    method: 'post',
    data:data
  })
}

//帖子详情
export function tiezi_detail(data) {
  return request({
    url: 'tiezi_detail',
    method: 'post',
    data:data
  })
}

//新增保存帖子
export function user_save_tiezi(data) {
  return request({
    url: 'user_save_tiezi',
    method: 'post',
    data:data
  })
}

//帖子评论
export function user_save_pinglun(data) {
  return request({
    url: 'user_save_pinglun',
    method: 'post',
    data:data
  })
}

//查看自己的帖子列表
export function tiezi_new_list(data) {
  return request({
    url: 'tiezi_new_list',
    method: 'post',
    data:data
  })
}

//博客详情
export function boke_detail(data) {
  return request({
    url: 'boke_detail',
    method: 'post',
    data:data
  })
}

//发布博客
export function user_boke_save(data) {
  return request({
    url: 'user_boke_save',
    method: 'post',
    data:data
  })
}

//会员删除博客
export function user_boke_delete(data) {
  return request({
    url: 'user_boke_delete',
    method: 'post',
    data:data
  })
}

//会员查看自己的博客列表
export function boke_new_list(data) {
  return request({
    url: 'boke_new_list',
    method: 'post',
    data:data
  })
}

//会员删除帖子
export function user_tiezi_delete(data) {
  return request({
    url: 'user_tiezi_delete',
    method: 'post',
    data:data
  })
}

//检索
export function user_search(data) {
  return request({
    url: 'user_search',
    method: 'post',
    data:data
  })
}

//查看他人博客
export function ta_boke_list(data) {
  return request({
    url: 'ta_boke_list',
    method: 'post',
    data:data
  })
}


// WEBPACK FOOTER //
// ./src/api/boke.js